/**
 * @prettier
 */
import { TimeZones } from 'src/constants/TimeZone';
import type { TimeZoneName } from 'src/types/Id';

export function getDeviceTimeZone(): TimeZoneName {
    return TimeZones.AMERICA_MONTERREY;
}
